import { computed } from 'vue'
import { usePage } from '@inertiajs/vue3'

// The server already renders the SEO <title> for every public page
// (Public::BaseController#set_og → shared `seo_title` prop). Pages reuse it
// client-side so the browser tab never swaps to a second, shorter title after
// hydration (2026-10-29 review: /ru showed just "Get Phuket", /ru/charters a
// different title from the one search engines see). Pages keep their own
// i18n title as the fallback for the rare action that sets no og title.
export function usePublicTitle() {
  const page = usePage()
  return computed(() => page.props.seo_title || '')
}
